






























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { LocaleMessage } from "vue-i18n";

@Component({
  computed: {
    ...mapGetters("ui", ["nightMode"]),
  },
})
export default class PaginationPageInput extends Vue {
  @Prop({ required: true }) public isVisible: boolean;
  @Prop({ required: true }) public pageCount: number;
  @Prop({ required: true }) public isMobile: boolean;

  private query: string | null = null;
  private placeholder: LocaleMessage | null = null;
  private hasError = false;
  private nightMode: boolean;

  get hasInput() {
    return !!this.query;
  }

  @Watch("isMobile")
  public onIsMobileChanged(showMobile: boolean) {
    this.setPlaceholder(showMobile);
  }

  public mounted() {
    this.setPlaceholder(this.isMobile);
  }

  private search() {
    if (!this.query) {
      return;
    }

    const pageNumber = parseInt(this.query, 10);

    if (!pageNumber || pageNumber < 1 || pageNumber > this.pageCount) {
      this.hasError = true;
      setTimeout(() => (this.hasError = false), 1500);
    } else {
      this.emitPageChange(pageNumber);
    }
  }

  private setPlaceholder(showMobile: boolean) {
    this.placeholder = showMobile
      ? this.$i18n.t("PAGINATION.PLACEHOLDER.SHORT")
      : this.$i18n.t("PAGINATION.PLACEHOLDER.LONG");
  }

  private emitPageChange(page: number) {
    this.$emit("page-change", page);
  }

  private emitClose() {
    this.$emit("close");
  }
}
